import { Switch } from "Components/Form/Switch";
import { useTexts } from "Components/TextContext";
import { QuestionProps } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/FormComponentsHouseProducts/SafetyMeasureQuestions/QuestionProps";
import React from "react";

interface HasBurglarAlarmFormValues {
  hasBurglarAlarm: boolean;
}

export const BurglarAlarmSwitch = ({
  formProps,
  recalculatePrice,
}: QuestionProps<HasBurglarAlarmFormValues>): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <Switch
      id="hasBurglarAlarm"
      name="hasBurglarAlarm"
      label={getText("houseform.label.hasburglaralarm")}
      onChange={(event) => {
        const selected = Boolean(event.target.checked);
        recalculatePrice({
          ...formProps.values,
          hasBurglarAlarm: selected,
        });
      }}
    />
  );
};
